import React, { useMemo } from "react";
import { ChatListItem } from "@web-src/modules/chats/components/ChatListItem";
import { ChatListItemLastMessage } from "@web-src/modules/chats/components/ChatListItemLastMessage";
import { tokenizeMessageBody } from "@web-src/modules/chats/utils";
import { CHAT_MESSAGE_PAYLOAD_VERSION } from "@jugl-web/utils/consts";
import { useTranslations } from "@jugl-web/utils";
import { VoiceConversationModel } from "@jugl-web/rest-api";
import { VoiceConversationTopicPill } from "../../../VoiceConversationSummary/components/VoiceConversationTopicPill";
import { VoiceTransferredCallBadge } from "../../../VoiceConversationSummary/components/VoiceTransferredCallBadge";
import { useClientSupportPageContext } from "../../../../providers/ClientSupportPageProvider/useClientSupportPageContext";
import { ReactComponent as UserIcon } from "./assets/user.svg";

export const VoiceConversationTile: React.FC<{
  conversation: VoiceConversationModel;
  searchQuery?: string;
}> = ({ conversation, searchQuery }) => {
  const { t } = useTranslations();
  const { selectedConversation, selectConversation } =
    useClientSupportPageContext();

  const lastMessageBody = useMemo(
    () => conversation.payload.text || "",
    [conversation]
  );

  const displayName = useMemo(() => {
    return (
      conversation.contact_info?.name ||
      conversation.name ||
      t({ id: "common.unknown", defaultMessage: "Unknown" })
    );
  }, [conversation.contact_info?.name, conversation.name, t]);

  return (
    <ChatListItem
      variant="inbox"
      img={
        <div
          className="flex h-10 w-10 items-center justify-center rounded-full"
          style={{
            background: "linear-gradient(180deg, #CECED3 0%, #ECEFF0 69.27%)",
          }}
        >
          <UserIcon />
        </div>
      }
      chatId={conversation.conv_id}
      onClick={() => selectConversation(conversation)}
      timestamp={conversation.payload.timestamp}
      isSelected={selectedConversation?.conv_id === conversation.conv_id}
      title={displayName}
      lastMessageContent={
        <ChatListItemLastMessage
          payloadVersion={CHAT_MESSAGE_PAYLOAD_VERSION}
          tokenizedMessage={tokenizeMessageBody(lastMessageBody)}
        />
      }
      searchQuery={searchQuery}
      hasChatAccess
      additionalContent={
        <div className="flex items-center gap-2">
          <div className="min-w-0">
            <VoiceConversationTopicPill
              topic={conversation.last_summary_topic}
            />
          </div>
          {conversation.transferred && <VoiceTransferredCallBadge />}
        </div>
      }
    />
  );
};
